export default __webpack_public_path__ + "static/tropykus-5830e1cb38b232f6f207b0741d634837.svg";